/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

// reCAPTCHA Enterprise action for creating a pass reservation. This must match
// the action the ActivityPassService verifies the assessment against.
export const RECAPTCHA_SECTION = 'create_reservation';

// Version string sent alongside the token. The backend defaults anything that
// isn't "V2"/"V3" to the Enterprise verifier.
export const RECAPTCHA_SCORE = 'AUDIT';
export const RECAPTCHA_CHALLENGE = 'ASSESS';

export const MOBILE_TYPES = ['ENTERPRISE_IOS', 'ENTERPRISE_ANDROID'];

// Error messages surfaced to the user when reCAPTCHA verification hard-fails.
// The challenge-control signals ("additional challenge required" /
// "challenge failed") are now recognized inside the shared-ui
// useRecaptchaWithFallback hook, so they no longer live here.
export const RECAPTCHA_ERROR =
    'Our system has detected abnormal activity from your computer network. Please try again.';
export const RECAPTCHA_ERROR2 =
    'Our system has detected abnormal activity from your computer network. Please try refreshing the page or re-logging into your account.';
